
    import './styles.scoped.css';
    export default {
  "grid": "awsui_grid_1hw7z_1ywbc_1",
  "grid-compact": "awsui_grid-compact_1hw7z_1ywbc_8",
  "columns-1": "awsui_columns-1_1hw7z_1ywbc_13",
  "columns-2": "awsui_columns-2_1hw7z_1ywbc_17",
  "columns-4": "awsui_columns-4_1hw7z_1ywbc_21",
  "columns-6": "awsui_columns-6_1hw7z_1ywbc_25",
  "grid__item": "awsui_grid__item_1hw7z_1ywbc_29"
};
  